import React, {useState} from "react";
import ExcelJS from "exceljs";
import {Alert, Dropdown} from "@deere/ux.uxframe-react";
import {format, parseISO} from "date-fns";
import wtyReportApi from "../../services/warrantyReportAxios";
import {useSelector} from "react-redux";
import {dealerSearchData, searchedPin,} from "../machine-search/machineSearchSlice";
import {languageResponseData} from "../Translation/translationSerachSlice";
import {useHistory} from "react-router-dom/cjs/react-router-dom.min";

const ExportMachineList = ({machines, searchType, customer}) => {
    const [alertMessage, setAlertMessage] = useState("");
    const history = useHistory();

    const searchedSerial = useSelector(searchedPin);
    const dealerSearchDataObject = useSelector(dealerSearchData);

    let errorMessage = "";

    /*Function to fetch all the Machines for Search Criteria*/
    const getAllMachineForExportAll = async () => {
        try {
            /*if (searchType === "machines" && )*/
            let params = {};
            const dealerQueryObject = dealerSearchDataObject?.dealerQueryObj;
            let response;

            /*
             * If we are searching for Partial PIN or Customer Machines we can get the Search Data from the Existing Machine List.
             * We will have to store the Search Query data for all kind of search in future to have the Search Data available wherever needed.
             * */

            if (searchType === "machines") {
                params = {
                    searchType: "partial-pin",
                    partialPin: searchedSerial,
                };

                response = await wtyReportApi.post(
                    "/machine-search/machine-list-for-export",
                    {},
                    {},
                    params
                );
            } else if (searchType === "dealer") {
                params = {
                    searchType: "dealer-machines",
                };
                response = await wtyReportApi.post(
                    "/machine-search/machine-list-for-export",
                    dealerQueryObject,
                    {},
                    params
                );
            } else if (searchType === "customer") {
                params = {
                    searchType: "customer-machines",
                    ckcEntityId: machines[0]?.entityId,
                };
                response = await wtyReportApi.post(
                    "/machine-search/machine-list-for-export",
                    {},
                    {},
                    params
                );
            }

            if (response.status !== 200) {
                new Error("Calling api to get Expiration report failed.");
            }
            return await response.data?.machines;
        } catch (error) {
            errorMessage = error.message;
        }
    };

    let machineListHeader = [],
        machineListData = [],
        customerDetailsHeader = [],
        customerDetailsData = [];
    /*if (searchType === "machines" && searchType === "dealer") {
          // TODO: Commented the data and header for the Open PIP column

      }*/
    let fileName = "";

    if (searchType === "machines") {
        fileName = `MachineSearch-${machines[0]?.ntvPin?.slice(-6)}.xlsx`;
    } else if (searchType === "dealer") {
        fileName = `Dealer_${machines[0]?.serviceDealerNum}.xlsx`;
    } else if (searchType === "customer") {
        fileName = `Customer_${machines[0]?.entityId}.xlsx`;
    }

    const handleExportMachineList = async () => {
        prepareMachineDataForExport(machines);

        const workbook = new ExcelJS.Workbook();
        const machineSearchSheet = workbook.addWorksheet("MachineSearch");

        if (searchType === "customer") {
            customerDetailsHeader?.forEach((row) => {
                const cell = machineSearchSheet.addRow(row);
                cell.eachCell({includeEmpty: true}, (cell, cellNum) => {
                    cell.style.font = {bold: true};
                    cell.style.alignment = {horizontal: "left"};
                });
            });

            customerDetailsData?.forEach((row, rowNumber) => {
                let cell = machineSearchSheet.addRow(row);
                cell = machineSearchSheet.addRow();
            });
        }

        machineListHeader?.forEach((row) => {
            const cell = machineSearchSheet.addRow(row);
            cell.eachCell({includeEmpty: true}, (cell, cellNum) => {
                cell.style.font = {bold: true};
                cell.style.alignment = {horizontal: "left"};
            });
        });
        machineListData?.forEach((row, rowNumber) => {
            const cell = machineSearchSheet.addRow(row);
        });

        const blob = await workbook.xlsx.writeBuffer();

        const blobURL = window.URL.createObjectURL(new Blob([blob]));
        const a = document.createElement("a");
        a.href = blobURL;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(blobURL);
    };

    const handleExportMachineListAll = async () => {
        setAlertMessage(
            "The export of all records may take some time. You can continue using Warranty Reports while the download is in progress."
        );

        /*if(searchType === "dealer") {
                alert("The export of all records may take some time. You can continue using Warranty Reports while the download is in progress.");
            }*/


        const allMachines = await getAllMachineForExportAll();

        prepareMachineDataForExport(allMachines);

        const workbook = new ExcelJS.Workbook();
        const machineSearchSheet = workbook.addWorksheet("MachineSearch");

        if (searchType === "customer") {
            customerDetailsHeader?.forEach((row) => {
                const cell = machineSearchSheet.addRow(row);
                cell.eachCell({includeEmpty: true}, (cell, cellNum) => {
                    cell.style.font = {bold: true};
                    cell.style.alignment = {horizontal: "left"};
                });
            });

            customerDetailsData?.forEach((row, rowNumber) => {
                let cell = machineSearchSheet.addRow(row);
                cell = machineSearchSheet.addRow();
            });
        }

        machineListHeader?.forEach((row) => {
            const cell = machineSearchSheet.addRow(row);
            cell.eachCell({includeEmpty: true}, (cell, cellNum) => {
                cell.style.font = {bold: true};
                cell.style.alignment = {horizontal: "left"};
            });
        });

        machineListData?.forEach((row, rowNumber) => {
            const cell = machineSearchSheet.addRow(row);
        });

        const blob = await workbook.xlsx.writeBuffer();

        const blobURL = window.URL.createObjectURL(new Blob([blob]));
        const a = document.createElement("a");
        a.href = blobURL;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(blobURL);
    };

    const prepareMachineDataForExport = (machines) => {
        machineListHeader = [
            [
                "PIN",
                "Model",
                "Description",
                "Model Year",
                "Sold As",
                "Last Rep meas.",
                "Delivery Date",
                /*'Open PIP',*/ "Responsible Dealer",
                "Cust Name" /*'Warranty Option', 'Exp. date', 'Expires in Days'*/,
            ],
        ];
        customerDetailsHeader = [
            [
                "Customer Name",
                "Address",
                "Home Phone",
                "Cell Phone",
                "Business Phone",
                "CKC #",
            ],
        ];

        machineListData = machines?.map(
            ({
                 pinNumber17,
                 pinNumber13,
                 ntvPin,
                 modelName,
                 modelDescription,
                 modelYear,
                 newUsedIndicator,
                 deliveryReceiptDate,
                 serviceDealerNum,
                 firstName,
                 middleName,
                 lastName,
                 businessName1,
                 businessName2,
             }) => {
                const soldAs =
                    newUsedIndicator?.length > 1
                        ? newUsedIndicator
                        : newUsedIndicator === "N"
                            ? "New"
                            : newUsedIndicator === "U"
                                ? "Used"
                                : "";
                const indCustomerName = [firstName, middleName, lastName]
                    .map((name) => name?.trim())
                    .filter(Boolean)
                    .join(" ");
                const customerName =
                    businessName1?.trim() ||
                    businessName2?.trim() ||
                    indCustomerName ||
                    "N/A";
                // Remove the time zone offset from deliveryReceiptDate
                const dateWithoutOffset = deliveryReceiptDate?.slice(0, -6);
                const dateObj = parseISO(dateWithoutOffset);
                let formattedDeliveryDate;
                if (!isNaN(dateObj)) {
                    formattedDeliveryDate = format(dateObj, "dd MMM yyyy");
                } else {
                    formattedDeliveryDate = "";
                }
                // TODO: Commented the data and header for the Open PIP column
                return [
                    pinNumber17 || ntvPin || pinNumber13,
                    modelName,
                    modelDescription,
                    modelYear,
                    soldAs,
                    "",
                    formattedDeliveryDate,
                    /*'',*/ serviceDealerNum,
                    customerName,
                    "",
                    "",
                    "",
                ];
            }
        );

        if (searchType === "customer") {
            const {
                lastName,
                firstName,
                middleName,
                businessName1,
                businessName2,
                homePhone,
                mobilePhone,
                workPhone,
                entityId
            } = customer;
            const {street, street2, city, state, country, postalCode} =
                customer.addresses[0];
            const businessName = `${businessName1 ? businessName1 : ""} ${
                businessName2 ? businessName2 : ""
            }`.trim();
            const indCustomerName = [firstName, middleName, lastName]
                .map((name) => name?.trim())
                .filter(Boolean)
                .join(" ");
            const custName =
                indCustomerName?.length > 0 ? indCustomerName : businessName;

            let address = `${street} ${street2 ? street2 : ""} ${city ? city : ""} ${
                state ? state : ""
            } ${country ? country : ""} ${postalCode ? postalCode : ""}`;
            const homePhoneData = homePhone ? `${homePhone.countryCode ? homePhone.countryCode : ""}${homePhone.areaCode ? homePhone.areaCode : ""}${homePhone.phoneNumber ? homePhone.phoneNumber : ""}` : "";
            const mobilePhoneData = mobilePhone ? `${mobilePhone.countryCode ? mobilePhone.countryCode : ""}${mobilePhone.areaCode ? mobilePhone.areaCode : ""}${mobilePhone.phoneNumber ? mobilePhone.phoneNumber : ""}` : "";
            const workPhoneData = workPhone ? `${workPhone.countryCode ? workPhone.countryCode : ""}${workPhone.areaCode ? workPhone.areaCode : ""}${workPhone.phoneNumber ? workPhone.phoneNumber : ""}` : "";

            customerDetailsData = [
                [
                    custName,
                    address,
                    homePhoneData,
                    mobilePhoneData,
                    workPhoneData,
                    entityId,
                ],
            ];
        }
    };

    const onCloseAlert = () => {
        setAlertMessage("");
    };
    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
        return translationsResponse[key] || defaultText;
    };
    return (
        <>
            <Dropdown>
                <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                    {translate("export_data", "Export Data")}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item href="#" onClick={handleExportMachineList}>
                        {translate("exportexcel", " Export To Excel")}
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={handleExportMachineListAll}>
                        {translate("export_all", "Export All")}
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>

            {alertMessage && alertMessage !== "" && searchType === "dealer" ? (
                <Alert
                    dismissible
                    onClose={onCloseAlert}
                    accessibilityLabel="Info:"
                    variant="info"
                    aria-atomic="true"
                >
                    <span className="uxf-alert-title info-content">{alertMessage}</span>
                </Alert>
            ) : null}
        </>
    );
};

export default ExportMachineList;
